const APLUS_A1 = "9ad1ec64-7d75-11e9-9c8e-0242ac140002";
const A_A2 = "9ad1eca5-7d75-11e9-9c8e-0242ac140002";
const AMINUS_A3 = "9ad1ecef-7d75-11e9-9c8e-0242ac140002";
const FANNIE_MAE = "9ad1ed3a-7d75-11e9-9c8e-0242ac140002";
const FREDDIE_MAC = "9ad1ed88-7d75-11e9-9c8e-0242ac140002";
const COLLATERAL_POSTING = "9ad1edd6-7d75-11e9-9c8e-0242ac140002";
export const map = {
  APLUS_A1,
  A_A2,
  AMINUS_A3,
  FANNIE_MAE,
  FREDDIE_MAC,
  COLLATERAL_POSTING
};

export const list = [
  { name: "A+/A1", label: "A+/A1", value: APLUS_A1 },
  { name: "A/A2", label: "A/A2", value: A_A2 },
  { name: "A-/A3", label: "A-/A3", value: AMINUS_A3 },
  { name: "Fannie Mae", label: "Fannie Mae", value: FANNIE_MAE },
  { name: "Freddie Mac", label: "Freddie Mac", value: FREDDIE_MAC },
  { name: "Collateral Posting", label: "Collateral Posting", value: COLLATERAL_POSTING }
];

export default {
  map,
  list
};
